// removed by extract-text-webpack-plugin
module.exports = {"BackArrow":"_2JbC_BackArrow","White":"_2ff8_White","svgGroup":"_3EoH_svgGroup"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/BackArrow.module.scss
// module id = 403
// module chunks = 42